import React from 'react';
import { useFirebase } from '../../../../services/firebase';
import { usePreferences } from '@trycourier/react-hooks';
import PreferenceSection from './PreferenceSection';
import ProgressBar from '../../../common/ProgressBar';
import AlertBox from '../../../common/AlertBox';

interface NotificationPreferencesProps {}

const NotificationPreferences: React.FC<NotificationPreferencesProps> = (
  props
) => {
  const { isAdmin } = useFirebase();
  const preferences = usePreferences();

  if (preferences.isLoading) {
    return <ProgressBar indeterminate />;
  }
  if (!preferences.preferencePage) {
    return (
      <div>
        <AlertBox
          type="error"
          text="Error loading notification preferences. Please try again later."
        />
      </div>
    );
  }

  return (
    <div>
      {preferences.preferencePage.sections.nodes.map((section, i) => (
        <PreferenceSection key={i} section={section} isAdmin={isAdmin} />
      ))}
    </div>
  );
};

export default NotificationPreferences;
